import { request } from '@sweetspot/shared/data-access/api-platform'
import { getApiPlatformBaseUrl } from '@sweetspot/shared/util/functions'
import { ImportMembershipResult } from './types'

/**
 * Start import of membership invites
 */
export const importMembershipInvites = (file: FormData): Promise<ImportMembershipResult> => {
  const URL = `${getApiPlatformBaseUrl()}/membership-player-invites/import`

  return request(URL, {
    method: 'POST',
    contentType: 'multipart/form-data',
    body: file,
  })
}
